import React from 'react';
import type { DataClass } from '../api/envelope';
import './DataClassBadge.css';

// The server-derived data_class: is this LIVE tenant data, a starter/template, redacted, or public-safe?
// The UI never invents it — it comes from the response envelope. Surfacing it tells the operator, at a
// glance, how much to trust what they're looking at.
const LABEL: Record<DataClass, string> = {
  live: 'Live',
  starter: 'Starter',
  template: 'Template',
  redacted: 'Redacted',
  public_safe: 'Public',
};

const TIP: Record<DataClass, string> = {
  live: 'Live tenant data',
  starter: 'Starter/seed data — not yet your live record',
  template: 'Template content',
  redacted: 'Some fields hidden by your role',
  public_safe: 'Public-safe view',
};

export function DataClassBadge({ dataClass }: { dataClass?: DataClass }): React.ReactElement | null {
  if (!dataClass) return null;
  return (
    <span className={`dataClassBadge dc-${dataClass}`} data-tip={TIP[dataClass]} aria-label={TIP[dataClass]}>
      {LABEL[dataClass]}
    </span>
  );
}
